import { useMutation, useQueryClient } from '@tanstack/react-query'
import { customerAccountKeys } from '@/entities/customer-account'
import { apiRequest } from '@/shared/api'

function useAccessInvalidation(accountId: string, companyId: string) {
  const qc = useQueryClient()
  return () => {
    void qc.invalidateQueries({ queryKey: customerAccountKeys.projectAccess(accountId) })
    void qc.invalidateQueries({ queryKey: customerAccountKeys.byCompany(companyId) })
  }
}

export function useGrantAccess(accountId: string, companyId: string) {
  const invalidate = useAccessInvalidation(accountId, companyId)
  return useMutation({
    mutationFn: (projectId: string) =>
      apiRequest({
        method: 'POST',
        url: `/customer-accounts/${accountId}/project-access`,
        body: { project_id: projectId },
      }),
    onSuccess: invalidate,
  })
}

export function useRevokeAccess(accountId: string, companyId: string) {
  const invalidate = useAccessInvalidation(accountId, companyId)
  return useMutation({
    mutationFn: (projectId: string) =>
      apiRequest({
        method: 'DELETE',
        url: `/customer-accounts/${accountId}/project-access/${projectId}`,
      }),
    onSuccess: invalidate,
  })
}
